<template>
  <AnalyticsWidget
    title="Inventory Treemap"
    subTitle="Visual representation of inventory distribution"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">

    <div class="h-100 p-2">

      <ReportFilterPopover
        headerTitle="Stock Treemap Filter"
        :showApplyButton="true"
        :showResetButton="true"
        :appendToBody="true"
        alignment="left"
        placement="bottom-end"
        @apply="applyStockTreemapFilter"
        @reset="resetStockTreemapFilter">
        <template v-slot:popover>
          <FormRow label="Group By">
            <FormSelect v-model="editingStockTreemapFilter.type" :options="groupTypeLookup" />
          </FormRow>
        </template>
        <template v-slot:filterDisplay>
          <div>
            <i class="far fa-filter mr-2"></i>{{formatLookupName(appliedStockTreemapFilter.type, groupTypeLookup)}}
          </div>                
        </template>
      </ReportFilterPopover>

      <LoadingPanel :loading="loading" />

      <ChartTreeMap
        v-if="!loading && treeMapSeries.length > 0"
        title="Stock Distribution"
        :series="treeMapSeries"
        :options="chartOptions"
      />
    </div>

  </AnalyticsWidget>
</template>


<script>
import moment from 'moment'

import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import ReportFilterPopover from '@/components/reporting/reportFilterPopover'

import ChartTreeMap from '@/components/charts/chartTreeMap'

export default {
  name: 'InventoryStockTreeMapWidget',
  components: {
    AnalyticsWidget,
    ReportFilterPopover,
    ChartTreeMap
  },
  props: {
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    
  },
  data() {
    return {
      loading: true,
      glassTreeMapData: [],
      treeMapSeries: [],
      chartOptions: {},

      groupTypeLookup: [
        { value: 'area', name: 'Area' },
        { value: 'value', name: 'Value' },
        { value: 'sheets', name: 'Sheets' }
      ],

      defaultStockTreemapFilter: {    
        type: 'area'
      },
      editingStockTreemapFilter: {},
      appliedStockTreemapFilter: {},
    }
  },
  mounted() {
    this.editingStockTreemapFilter = _.clone(this.defaultStockTreemapFilter)
    this.appliedStockTreemapFilter = _.clone(this.defaultStockTreemapFilter)

    this.requestData()
  },
  methods: {
    requestData() {
      var params = {
        type: this.appliedStockTreemapFilter.type
      }

      this.chartOptions.tooltip = {
        show: true,
        trigger: "item",
        //formatter: "{b}: {c}"
        valueFormatter: (value) => {
          if(this.appliedStockTreemapFilter.type == 'value') {
            return this.formatCurrency(value);
          }
          if(this.appliedStockTreemapFilter.type == 'area') {
            return this.formatDecimal(value, 2, true) + 'm2';
          }
          return this.formatInteger(value, false, true);
        }
      },

      this.$apiService.analyticsService.getStockOnHandTreeMap(params)
      .then(response => {
        // Process the response data
        this.glassTreeMapData = response.data

        // If top level is a single item, remove that & jump straight to the next level
        // Helps improve visibility with the treemap & colours
        if(this.glassTreeMapData.length == 1) {
          this.glassTreeMapData = this.glassTreeMapData[0].children
        }

        this.treeMapSeries = [{
          name: 'Stock Area',
          type: 'treemap',
          visibleMin: 300,
          colorMappingBy: 'index',
          label: {
            show: true,
            formatter: '{b}'
          },
          itemStyle: {
            borderColor: '#fff'
          },
          levels: [
            {
              itemStyle: {
                borderWidth: 0,
                gapWidth: 5
              }
            },
            {
              itemStyle: {
                gapWidth: 1
              }
            },
            {
              colorSaturation: [0.35, 0.5],
              itemStyle: {
                gapWidth: 1,
                borderColorSaturation: 0.6
              }
            }
          ],
          data: this.glassTreeMapData,
        }]
      })
      .finally(() => {
        this.loading = false
      })
    },
    applyStockTreemapFilter() {
      this.appliedStockTreemapFilter = _.clone(this.editingStockTreemapFilter)
      this.requestData()
    },
    resetStockTreemapFilter() {
      this.editingStockTreemapFilter = _.clone(this.defaultStockTreemapFilter)
      this.appliedStockTreemapFilter = _.clone(this.defaultStockTreemapFilter)
      this.requestData()
    }
  }
}
</script>